import React from 'react';
import { connect } from 'react-redux';

import Loader from '../Loader';

import {
  revokeEmrManagerRoleLoadingSelector,
  revokeEmrManagerRoleErrorSelector
} from '../../redux/selectors';

import { revokeEmrManagerRoleFromAdminStart } from '../../redux/actions';

const RevokeEmrManagerRoleButton = ({ adminId, loading, error, revokeEmrManagerRoleFromAdminStart }) => {
  if (loading) return <Loader />;
  if (error) return "";

  return <a onClick={() => revokeEmrManagerRoleFromAdminStart({ adminId })}>Revoke Emr Manager</a>
}

const mapStateToProps = (state, adminId) => ({
  loading: revokeEmrManagerRoleLoadingSelector(state, adminId),
  error: revokeEmrManagerRoleErrorSelector(state, adminId)
});

const mapDispatchToProps = {
  revokeEmrManagerRoleFromAdminStart
};

export default connect(mapStateToProps, mapDispatchToProps)(RevokeEmrManagerRoleButton);
